import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {PaymentMethodsPage} from "../payment-methods/payment-methods";
import {PaymentHistoryPage} from "../payment-history/payment-history";

/**
 * Generated class for the PaymentsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-payments',
  templateUrl: 'payments.html',
})
export class PaymentsPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
  }

  ionViewDidLoad() {

  }

  openPaymentMethodsPage() {
    this.navCtrl.push(PaymentMethodsPage);
  }

  openPaymentHistoryPage() {
    this.navCtrl.push(PaymentHistoryPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/payments/payments.ts